/**
 * <summer-sale-banner> custom element.
 *
 * Live countdown to a merchant-set end date/time. Counts down in
 * days/hours/minutes/seconds; when the sale ends it swaps in the
 * "ended" message (and optionally hides the whole banner). Dismiss
 * state is remembered per-browser via localStorage so a shopper who
 * closes it doesn't see it again this sale.
 *
 * Accepts (data attributes):
 * - data-end: ISO 8601 date/time string, e.g. "2026-08-31T23:59:59+01:00"
 * - data-dismiss-key: localStorage key used to remember a dismissal
 * - data-hide-on-end: "true" to hide the whole banner once the sale ends
 */
(function () {
  if (customElements.get('summer-sale-banner')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class SummerSaleBanner extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.dataset.end);
      this.hideOnEnd = this.dataset.hideOnEnd === 'true';
      this.dismissKey = this.dataset.dismissKey || '';

      this.countdownEl = this.querySelector('[data-countdown]');
      this.endedEl = this.querySelector('[data-ended]');
      this.closeBtn = this.querySelector('[data-close]');

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minsEl = this.querySelector('[data-minutes]');
      this.secsEl = this.querySelector('[data-seconds]');

      if (this.dismissKey && window.localStorage) {
        try {
          if (window.localStorage.getItem(this.dismissKey) === 'true') {
            this.setAttribute('hidden', '');
            return;
          }
        } catch (e) {
          /* localStorage unavailable — ignore, banner just always shows */
        }
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.setAttribute('hidden', '');
          if (this.dismissKey && window.localStorage) {
            try {
              window.localStorage.setItem(this.dismissKey, 'true');
            } catch (e) {
              /* ignore */
            }
          }
        });
      }

      if (isNaN(this.endDate.getTime())) {
        return;
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      var diff = this.endDate.getTime() - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.countdownEl) this.countdownEl.setAttribute('hidden', '');
        if (this.endedEl) this.endedEl.removeAttribute('hidden');
        if (this.hideOnEnd) this.setAttribute('hidden', '');
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minsEl) this.minsEl.textContent = pad(minutes);
      if (this.secsEl) this.secsEl.textContent = pad(seconds);
    }
  }

  customElements.define('summer-sale-banner', SummerSaleBanner);
})();
